import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";


export function* handleLoginUser({ data }) {
  const { navigate, ...rest } = data;
  try {
    const response = yield axios.post(`${baseURL}/auth/signin`, rest);
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(
        actions.loginUserSuccess({
          user: response.data.data,
          navigate,
          shouldNavigate: true,
        })
      );
    } else {
      AntdAlert.error(message);
      yield put(actions.loginUserError());
    }
  } catch (error) {
    yield put(actions.loginUserError());
    AntdAlert.error('Your Email or Password is incorrect. Please try again.');
    console.log(error);
  }
}


export function* handleLogoutUser({ data }) {
  const { navigate, id } = data;
  try {
    const response = yield axios.post(`${baseURL}/auth/signout`, { id });
    const { success, message } = response.data;
    if (success) {
      AntdAlert.success(message);
      yield put(actions.logoutUserSuccess({ ...response.data.data, navigate }));
      navigate("/");
    } else if (!success) {
      AntdAlert.error(message);
      yield put(actions.logoutUserError());
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleFetchSidebarProjects({ data }) {
  try {
    const response = yield axios.get(
      `${baseURL}/user_projects`,
      { params: { userId: data.userId } }
    );
    if (response.status === 200) {
      yield put(actions.fetchSidebarProjectSuccess(response.data.userProjects));
    } else {
      yield put(actions.fetchSidebarProjectError());
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchSidebarProjectError());
    console.log(error);
  }
}